import { render, staticRenderFns } from "./politicsProjectFlow.vue?vue&type=template&id=39421d1e&scoped=true"
import script from "./politicsProjectFlow.vue?vue&type=script&lang=js"
export * from "./politicsProjectFlow.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectFlow.vue?vue&type=style&index=0&id=39421d1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39421d1e",
  null
  
)

export default component.exports